import { get, post } from '../../Http/index'
import {  ASSET } from "../../config";
//保存资产
function assetSave(params){
    return post(`/api-finance-asset/asset/insert`,params)
}
//资产列表
function assetList(params){
    return post(`/api-finance-asset/asset/list`,params)
}
//详情
function assetDetail(id){
    return get(`/api-finance-asset/asset/${id}`,)
}
//删除
function assetDelete(params){
    return post(`/api-finance-asset/asset/delete`,params)
}
//检查是否可以更新
function updateCheck(params){
    return post(`/api-finance-asset/asset/updateCheck`,params)
}
//更新
function assetUpdate(params){
    return post(`/api-finance-asset/asset/update`,params)
}

function getInvoiceUrlList(params) {
    return post('/api-invoice-imagecenter/file/getImgUrls', params)
}

//资产折旧历史
function assetdepreciationhistoryList(params) {
    return post('/api-finance-asset/assetdepreciationhistory/findList', params)
}
//资产操作日志
function getassetoperatelogList(params) {
    return post('/api-finance-asset/assetoperatelog/findListToAsset',params )
}
//资产平台导入
function assetUploadPlatform(params) {
    return post('/api-finance-asset/asset/uploadPlatform',params )
}


//查询原值增加列表
function assetoriginalchangebillList(params){
    return post(`/api-finance-asset/assetoriginalchangebill/list`,params)
}
//查询资产清理列表
function assetclearbillList(params){
    return post(`/api-finance-asset/assetclearbill/list`,params)
}
//查询新增资产列表
function assetaddbillList(params){
    return post(`/api-finance-asset/assetaddbill/list`,params)
}
//查询折旧列表
function assetdepreciationrecordList(params){
    return post(`/api-finance-asset/assetdepreciationrecord/list`,params)
}
//原值变更报账
function assetoriginalchangebillReimBursement(params){
    return post(`/api-finance-asset/assetoriginalchangebill/reimBursement`,params)
}
//资产清理报账
function assetclearbillReimBursement(params){
    return post(`/api-finance-asset/assetclearbill/reimBursement`,params)
}

//折旧报账
function assetdepreciationrecordReimBursement(params){
    return post(`/api-finance-asset/assetdepreciationrecord/reimBursement`,params)
}

//新增资产报账
function assetaddbillReimBursement(params){
    return post(`/api-finance-asset/assetaddbill/reimBursement`,params)
}









export default {
    assetSave,
    assetDetail,
    assetList,
    assetDelete,
    updateCheck,
    assetUpdate,
    getInvoiceUrlList,
    assetdepreciationhistoryList,
    getassetoperatelogList,
    assetdepreciationrecordList,
    assetaddbillList,
    assetclearbillList,
    assetoriginalchangebillList,
    assetaddbillReimBursement,
    assetdepreciationrecordReimBursement,
    assetclearbillReimBursement,
    assetoriginalchangebillReimBursement,
    assetUploadPlatform
    



   
    

}



// WEBPACK FOOTER //
// ./src/api/assest-management/assets-register/index.js